// @flow
import * as _ from 'lodash';

const _getPlayerMatchStatus = (player: Object, round: Object) => {
	const players_match = round.matches.find(m =>
		m.home_squad_id === player.squad_id || m.away_squad_id === player.squad_id);

	if(!players_match) {
		return null;
	}

	return _.get(players_match, 'status', null);
};

export const getActiveEmergenciesForLineup =
	(lineup: Object, players_by_id: Object, round: Object) => {

		if(_.isEmpty(lineup.emergency)) {
			return [];
		}

		// filter out postions that don't have emergs set
		const position_ids_with_emergencies = Object.keys(lineup.emergency).filter(key => {
			return lineup.emergency[key] !== 0;
		});

		// check for DNP in players in these postions
		const position_ids_to_be_included = position_ids_with_emergencies.filter(id => {
			const dnps_with_position = lineup[id].filter(player_id => {
				if(_getPlayerMatchStatus(players_by_id[player_id], round) === 'scheduled') {
					return false;
				}
				const score = _.get(players_by_id, `${player_id}.stats.scores.${round.id}`, 'DNP');
				return score === 'DNP';
			});
			return dnps_with_position.length >= 1;
		});

		const eligable_player_ids = position_ids_to_be_included.map(position_id =>
			lineup.emergency[position_id]
		);

		// return player if he score
		// $FlowFixMe
		return eligable_player_ids.filter(player_id =>
			_.get(players_by_id, `${player_id}.stats.scores.${round.id}`, false)) || [];
	};

export default getActiveEmergenciesForLineup;


// WEBPACK FOOTER //
// ./src/helpers/team/getActiveEmergenciesForLineup.js